import Vue from 'vue';
import { gsap } from 'gsap';
import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';

Swiper.use([Navigation, Pagination]);

Vue.component('mobile-project-slider', {
    /**
     * Vue.js instance reactive data variables.
     *
     * @return {Object}
     */
    data() {
        return {
        };
    },

    /**
     * Called when the Vue.js instance is mounted and
     * ready for use.
     *
     * @return {void}
     */
    mounted() {
        this.swiperInit();
    },

    /**
     * Vue.js instance methods.
     *
     * @type {Object}
     */
    methods: {
        swiperInit() {
            this.slider = new Swiper(this.$refs.mobileProjectsSlider, {
                modules: [Navigation, Pagination],
                loop: false,
                breakpoints: {
                    0: {
                        slidesPerView: 1.2,
                        spaceBetween: 20,
                        slidesOffsetAfter: 40,
                    },
                    600: {
                        slidesPerView: 2.5,
                        spaceBetween: 40,
                        slidesOffsetAfter: 80,
                    },
                    1024: {
                        slidesPerView: 3.3,
                        spaceBetween: 40,
                        slidesOffsetAfter: 80,
                    },
                },
                navigation: {
                    nextEl: '.mobile-projects-button-next',
                    prevEl: '.mobile-projects-button-prev',
                },
                pagination: {
                    el: '.mobile-projects-pagination',
                    bulletClass: 'highlighted-item__pagination-bullet',
                    bulletActiveClass: 'highlighted-item__pagination-bullet--active',
                },
            });
        },

        onStartHover(e) {
            const isDesktop = document.querySelector('.no-touchevents');

            if (!isDesktop) {
                return;
            }

            const el = e.currentTarget;
            const tl = gsap.timeline();
            const image = el.querySelector('img') || el.querySelector('picture');
            const arrow = el.querySelector('svg');
            const arrowExtention = el.querySelector('.home-highlighted-items__arrow--animation');
            const overlay = el.querySelector('.home-highlighted-items__animation-overlay');

            tl
                .to(image, 0.8, {
                    scale: 1.1,
                    ease: 'power3.out',
                })
                .to(arrow, 0.8, {
                    x: 5,
                    ease: 'power3.out',
                }, '<')
                .to(arrowExtention, 0.8, {
                    x: -5,
                    ease: 'power3.out',
                }, '<')
                .to(overlay, 0.8, {
                    x: 0,
                    rotate: 0,
                    ease: 'power3.out',
                }, '<');
        },

        onResetHover(e) {
            const isDesktop = document.querySelector('.no-touchevents');

            if (!isDesktop) {
                return;
            }

            const el = e.currentTarget;
            const tl = gsap.timeline();
            const image = el.querySelector('img') || el.querySelector('picture');
            const arrow = el.querySelector('svg');
            const arrowExtention = el.querySelector('.home-highlighted-items__arrow--animation');
            const overlay = el.querySelector('.home-highlighted-items__animation-overlay');

            tl
                .to(image, 0.8, {
                    scale: 1,
                    ease: 'power3.out',
                })
                .to(arrow, 0.8, {
                    x: 0,
                    ease: 'power3.out',
                }, '<')
                .to(arrowExtention, 0.8, {
                    x: 0,
                    ease: 'power3.out',
                }, '<')
                .to(overlay, 0.8, {
                    x: '115%',
                    rotate: 13,
                    ease: 'power3.out',
                }, '<');
        },
    },
});
